export default "__VITE_ASSET__ColbJhVW__"